import { Faq } from "lib/types/datoBlocks";
import classNames from "classnames";
import ReactMarkdown from "markdown-to-jsx";

type FaqBlockProps = {
  list: Faq[];
};

const FaqBlock = ({ list }: FaqBlockProps) => {
  if (!list.length) return null;

  return (
    <ul className={"flex flex-col gap-[26px]"}>
      {list.map(({ id, question, answer }) => {
        return (
          <li
            key={id}
            className={"flex flex-col gap-4 lg:flex-row lg:items-start"}
          >
            <div
              className={
                "flex flex-none flex-row gap-4 text-black-rock lg:w-[375px]"
              }
            >
              <div
                className={
                  "flex h-[34px] w-[34px] flex-none items-center justify-center rounded-full bg-[#C8C8CC] font-bold text-[16px] leading-[130%]"
                }
              >
                Q.
              </div>
              <div className={"flex min-h-[34px] items-center"}>
                <p className={"font-bold text-[16px] leading-[130%]"}>
                  {question}
                </p>
              </div>
            </div>
            <div className={"ml-[51px] lg:ml-0"}>
              <ReactMarkdown
                className={classNames(
                  "text-[16px] leading-[130%] text-mono-70",
                  "[&_a]:inline [&_a]:underline [&_a]:[text-decoration-skip-ink:none] [&_a]:[text-underline-offset:2px]",
                  "focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring focus-visible:[&_a]:ring-black-rock"
                )}
                options={{ forceBlock: true }}
              >
                {answer}
              </ReactMarkdown>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default FaqBlock;
